'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '&:focus': {
        outline: 0
      }
    },
    label: {
      display: 'block',
      borderRadius: 4,
      margin: [[5, 10, 5, 0]],
      padding: [[1, 10]],
      border: [[1, 'solid']],
      cursor: 'pointer',
      position: 'relative'
    },
    labelSelected: {
      background: theme.colorCardTitle,
      color: theme.bgCardTitle
    },
    key: {
      fontSize: 12.5,
      marginLeft: 7
    }
  };
};

var LabelList = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(LabelList, _React$Component);

  function LabelList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LabelList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LabelList.__proto__ || Object.getPrototypeOf(LabelList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      labelList: [_constants.NO_LABEL],
      labelIds: [(0, _v2["default"])()]
    }, _this.updateLabels = function (labels) {
      var labelList = Array.isArray(labels) ? labels : [_constants.NO_LABEL];
      var labelIds = labelList.map(function (_) {
        return (0, _v2["default"])();
      });

      _this.setState({
        labelList: labelList,
        labelIds: labelIds
      });
    }, _this.handleSelect = function (ev) {
      return _this.props.handleSelect(ev.target.value);
    }, _this.handleShortcuts = function (action, ev) {
      var keymap = _this.props.keymap;
      var keymapByKey = (0, _util.invertObject)(keymap);

      switch (action) {
        case 'choice':
          ev.preventDefault();

          if (keymapByKey[event.key]) {
            _this.props.handleSelect(keymapByKey[event.key]);
          } else {
            var key = (0, _util.getNumberKey)(ev);

            var label = _this.props.labels[parseInt(key) - 1];

            if (label && typeof keymap[label] == 'undefined') {
              _this.props.handleSelect(label);
            }
          }

          break;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LabelList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateLabels(this.props.labels);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prev) {
      if (prev.labels !== this.props.labels) {
        this.updateLabels(this.props.labels);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          keymap = _props.keymap,
          selected = _props.selected,
          classes = _props.classes;
      var _state = this.state,
          labelList = _state.labelList,
          labelIds = _state.labelIds;
      var shortcutProps = {
        name: 'CARD',
        handler: this.handleShortcuts,
        targetNodeSelector: 'body',
        global: true
      };
      return _react2["default"].createElement(_util.ShortcutsWrapper, _extends({
        ctx: this.context.shortcuts
      }, shortcutProps), _react2["default"].createElement('div', {
        className: classes.root
      }, labelList.map(function (label, i) {
        var key = typeof keymap[label] !== 'undefined' ? keymap[label] : i + 1;
        var labelClassNames = (0, _classnames2["default"])(classes.label, _defineProperty({}, classes.labelSelected, selected == label));
        return _react2["default"].createElement('span', {
          key: label
        }, _react2["default"].createElement('input', {
          hidden: true,
          checked: selected == label,
          type: 'radio',
          name: 'label',
          id: labelIds[i],
          value: label,
          onChange: _this2.handleSelect
        }), _react2["default"].createElement('label', {
          className: labelClassNames,
          htmlFor: labelIds[i]
        }, label, _react2["default"].createElement('span', {
          className: classes.key
        }, key)));
      })));
    }
  }]);

  return LabelList;
}(_react2["default"].Component), _class2.defaultProps = {
  labels: [_constants.NO_LABEL],
  keymap: {}
}, _class2.propTypes = {
  labels: _propTypes2["default"].arrayOf(_propTypes2["default"].string),
  selected: _propTypes2["default"].string,
  handleSelect: _propTypes2["default"].func
}, _class2.contextTypes = {
  shortcuts: _propTypes2["default"].object
}, _temp2)) || _class);
exports["default"] = LabelList;